export default __webpack_public_path__ + "static/media/ic_monaco.0287981f.svg";